import { render, staticRenderFns } from "./aWorkDetailTaskItem.vue?vue&type=template&id=708d5d9f&scoped=true"
import script from "./aWorkDetailTaskItem.vue?vue&type=script&lang=js"
export * from "./aWorkDetailTaskItem.vue?vue&type=script&lang=js"
import style0 from "./aWorkDetailTaskItem.vue?vue&type=style&index=0&id=708d5d9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708d5d9f",
  null
  
)

export default component.exports